import React, { useState, useEffect, useRef } from "react"
import ReactModal from "react-modal"
import config from "react-global-configuration"

import SvgClose from "../_svgs/small/Close"

import "./_modal.scss"
import { parkingState } from "../../booking/zustand/parkingState"

const Modal = ({
  modifier = "",
  overlayModifier = "",
  bodyModifier = "",
  externalState = false,
  closeHandler = null,
  afterOpenHandler = null,
  noScrollToTop = false,
  hideClose = false,
  isOpen,
  children,
}) => {
  const [showModal, setShowModal] = useState(false)
  const locale = parkingState?.getState()?.locale || document.querySelector("html").getAttribute("lang")

  const modalInitialFocusRef = useRef(null)

  useEffect(() => {
    ReactModal.setAppElement("main")
    if (isOpen) {
      setShowModal(true)
    }
  }, [isOpen])

  useEffect(() => {
    if (externalState && typeof isOpen !== "undefined" && isOpen !== showModal) {
      setShowModal(isOpen)
    }
  }, [externalState, isOpen, showModal])

  const onAfterOpenHandler = (event) => {
    if (!noScrollToTop) window.scrollTo(0, 0)
    window.dispatchEvent(new CustomEvent("modal:render", { detail: { modal: { el: event.contentEl } } }))

    if (!hideClose && modalInitialFocusRef?.current) {
      modalInitialFocusRef.current.focus()
    }

    if (afterOpenHandler) {
      afterOpenHandler()
    }
  }

  const handleCloseModal = () => {
    if (closeHandler) {
      closeHandler()
    } else {
      setShowModal(false)
    }
  }

  let textKeys = {}
  try {
    if (typeof config !== "undefined" && config?.get && typeof config.get === "function") {
      const textKeysObject = config.get("textKeys")
      if (typeof textKeysObject === "object" && textKeysObject?.mainApp) {
        textKeys = textKeysObject.mainApp
      }
    }
  } catch {
    // config wasnt available, supress crash of component and let textKeys use fallback text
  }

  return (
    <div id="modal" className="modal">
      {/* {!externalState && <button onClick={handleOpenModal}>Trigger Modal</button>} */}

      <ReactModal
        onRequestClose={handleCloseModal}
        onAfterOpen={onAfterOpenHandler}
        closeTimeoutMS={200}
        isOpen={showModal}
        contentLabel="Pop op"
        className={`modal__box ${modifier}`}
        overlayClassName={overlayModifier}
        bodyOpenClassName={bodyModifier}
      >
        {!hideClose && (
          <button
            ref={modalInitialFocusRef}
            aria-label={`${textKeys?.modalCloseAriaLabel || locale == "da" ? "Pop op med indhold åbnet - Luk Modal" : "Popup with content opened - Close Popup."}`}
            className="modal__close"
            onClick={handleCloseModal}
          >
            <SvgClose />
          </button>
        )}
        {children}
      </ReactModal>
    </div>
  )
}

export default Modal
